module.exports = __webpack_public_path__ + "static/usa-flag-a76cce890e8fe5ba0f1de66800693c0c.png";